var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4999 0.566406H0.49993C0.382073 0.566406 0.285645 0.662835 0.285645 0.780692V2.49498C0.285645 2.61283 0.382073 2.70926 0.49993 2.70926H21.4999C21.6178 2.70926 21.7142 2.61283 21.7142 2.49498V0.780692C21.7142 0.662835 21.6178 0.566406 21.4999 0.566406ZM21.4999 17.2807H0.49993C0.382073 17.2807 0.285645 17.3771 0.285645 17.495V19.2093C0.285645 19.3271 0.382073 19.4235 0.49993 19.4235H21.4999C21.6178 19.4235 21.7142 19.3271 21.7142 19.2093V17.495C21.7142 17.3771 21.6178 17.2807 21.4999 17.2807ZM21.4999 8.92355H0.49993C0.382073 8.92355 0.285645 9.01998 0.285645 9.13783V10.8521C0.285645 10.97 0.382073 11.0664 0.49993 11.0664H21.4999C21.6178 11.0664 21.7142 10.97 21.7142 10.8521V9.13783C21.7142 9.01998 21.6178 8.92355 21.4999 8.92355Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.85975cfbd672e8da2890bf71b3dee7ff.svg";
export { ForwardRef as ReactComponent };